import { string } from 'yup'

const cssFontSizeUnitRegex = /^\d+(?:\.\d+)?(?:px|em|rem|%|vw)$/i

export const cssFontSizeUnitSchema = string().matches(cssFontSizeUnitRegex)
